(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lifestyle-carousel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var videos = document.querySelectorAll('.lifestyle-carousel [data-lazy-video]');
    if (!videos.length) return;

    function whenIdle(fn) {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(fn, { timeout: 5000 });
      } else {
        setTimeout(fn, 2500);
      }
    }

    function sourceOf(video) {
      if (!video) return null;
      var source = video.querySelector('source');
      return source ? source.getAttribute('src') : video.getAttribute('src');
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            if (video.readyState === 0) {
              video.load();
            }
            var playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.catch(function () {});
            }
          } else {
            video.pause();
          }
        });
      },
      { rootMargin: '100px 0px', threshold: 0.25 }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });

    document.querySelectorAll('.lifestyle-carousel').forEach(function (root) {
      var lightbox = root.querySelector('[data-lightbox]');
      if (!lightbox) return;
      var lightboxVideo = lightbox.querySelector('[data-lightbox-video]');
      var spinner = lightbox.querySelector('[data-lightbox-spinner]');
      var triggers = root.querySelectorAll('[data-lightbox-trigger]');
      var closeEls = lightbox.querySelectorAll('[data-lightbox-close]');

      function getSourceForSlide(index) {
        var slide = root.querySelector('.lifestyle-carousel__slide[data-slide-index="' + index + '"]');
        if (!slide) return null;
        return sourceOf(slide.querySelector('video'));
      }

      function getPosterForSlide(index) {
        var slide = root.querySelector('.lifestyle-carousel__slide[data-slide-index="' + index + '"]');
        if (!slide) return null;
        var video = slide.querySelector('video');
        if (!video) return null;
        return video.getAttribute('data-poster') || video.getAttribute('poster');
      }

      // aquece o video antes do clique (mouse por cima ou dedo encostando)
      function warmUp(index) {
        var src = getSourceForSlide(index);
        if (!src) return;
        if (lightboxVideo.getAttribute('data-warm-src') === src) return;
        lightboxVideo.setAttribute('data-warm-src', src);
        var poster = getPosterForSlide(index);
        if (poster) lightboxVideo.setAttribute('poster', poster);
        lightboxVideo.preload = 'auto';
        lightboxVideo.src = src;
        lightboxVideo.load();
      }

      function showSpinnerWhileLoading() {
        if (!spinner) return;
        if (lightboxVideo.readyState >= 3) {
          spinner.hidden = true;
          return;
        }
        spinner.hidden = false;
        var hide = function () {
          spinner.hidden = true;
          lightboxVideo.removeEventListener('playing', hide);
          lightboxVideo.removeEventListener('canplay', hide);
        };
        lightboxVideo.addEventListener('playing', hide);
        lightboxVideo.addEventListener('canplay', hide);
      }

      function openLightbox(index) {
        var src = getSourceForSlide(index);
        if (!src) return;
        // se ja foi aquecido com o mesmo video, nao recomeca o download
        if (lightboxVideo.getAttribute('data-warm-src') !== src) {
          lightboxVideo.pause();
          lightboxVideo.preload = 'auto';
          lightboxVideo.src = src;
          lightboxVideo.setAttribute('data-warm-src', src);
          lightboxVideo.load();
        }
        lightboxVideo.muted = false;
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
        showSpinnerWhileLoading();
        var playPromise = lightboxVideo.play();
        if (playPromise !== undefined) {
          playPromise.catch(function () {});
        }
      }

      function closeLightbox() {
        lightboxVideo.pause();
        lightbox.hidden = true;
        if (spinner) spinner.hidden = true;
        document.body.style.overflow = '';
        // mantem o src em cache para reabrir instantaneo
      }

      triggers.forEach(function (trigger) {
        var index = trigger.getAttribute('data-slide-index');
        trigger.addEventListener('click', function () {
          openLightbox(index);
        });
        trigger.addEventListener('pointerenter', function () {
          warmUp(index);
        });
        trigger.addEventListener('touchstart', function () {
          warmUp(index);
        }, { passive: true });
      });

      closeEls.forEach(function (el) {
        el.addEventListener('click', closeLightbox);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !lightbox.hidden) {
          closeLightbox();
        }
      });

      // pre-carrega em segundo plano, com prioridade baixa,
      // so depois que a pagina terminou de carregar e o navegador esta ocioso
      window.addEventListener('load', function () {
        whenIdle(function () {
          root.querySelectorAll('.lifestyle-carousel__slide video').forEach(function (video) {
            var src = sourceOf(video);
            if (!src) return;
            var link = document.createElement('link');
            link.rel = 'prefetch';
            link.as = 'video';
            link.href = src;
            try { link.fetchPriority = 'low'; } catch (e) {}
            document.head.appendChild(link);
          });
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["zg-size-chart-image"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.zg-sizechart').forEach(function (root) {
      if (root.dataset.zgReady) return;
      root.dataset.zgReady = '1';

      var modal = root.querySelector('[data-sizechart-modal]');
      var openBtn = root.querySelector('[data-sizechart-open]');
      var closeEls = root.querySelectorAll('[data-sizechart-close]');
      if (!modal || !openBtn) return;

      function open() {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      }

      function close() {
        modal.hidden = true;
        document.body.style.overflow = '';
      }

      openBtn.addEventListener('click', open);

      closeEls.forEach(function (el) {
        el.addEventListener('click', close);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) close();
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
